import type Component from "video.js/dist/types/component";
export const getVideoJsComponent = (
  componentName:
    | "Button"
    | "FullscreenToggle"
    | "Component"
    | "MenuButton"
    | "MenuItem"
): typeof Component => {
  const THEOplayerInstance = window.THEOplayer;

  // THEOplayer.videojsのgetComponentは型定義が不完全なため、型アサーションを使用
  const VideoJsComponent = (
    THEOplayerInstance.videojs as unknown as {
      getComponent: (name: string) => typeof Component;
    }
  ).getComponent(componentName);

  return VideoJsComponent;
};
